import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { externalLayersKeys } from './queryKeys';
import type {
  ExternalLayer,
  ListExternalLayersFilter,
  ListExternalLayersQuery,
  ListLayersResponse,
} from './types';
import { buildSearchQueryParams } from 'hooks/shared/buildSearchQueryParams';

export const useListExternalLayersQuery = (
  query: ListExternalLayersQuery,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: externalLayersKeys.list(query),
    queryFn: async () => {
      const searchParams =
        buildSearchQueryParams<ListExternalLayersFilter>(query);

      const resp = await axios.get<ListLayersResponse<ExternalLayer>>(
        config.apiGateway.external_layers,
        {
          params: {
            ...searchParams,
            // API needs to be updated to "perPage"
            per_page: searchParams.perPage,
            include: 'incident',
          },
        }
      );

      return resp.data;
    },
    enabled: options?.enabled,
  });
};
